import styles from './ApplicationContentContainer.module.css'
import { ReactNode} from 'react'

interface ApplicationContentContainerProps {
    children?: ReactNode;
}

export const ApplicationContentContainer = (props: ApplicationContentContainerProps): JSX.Element => {
    const {
        children
    } = props

    return (
        <div className={styles.ApplicationContentContainer__Root}>
            { children }
        </div>
    )
}